import React, {Component} from 'react';
import Data from "./Data";
import {
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogContentText
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import axios from "axios";
import $ from "jquery";
import AES128 from "./AES128";

class Classes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            time:"",
            id:"",
            fields:{
                name:"",
                family:"",
                studentname:"",
                studentphone:"",
            },
            open:true,
            openReg:false,
            dialog:<div></div>,
            classinfo:{},
            errors : {

            }
        }
    }

    handleChange(event){
        let fields = this.state.fields;
        let target = event.target;
        fields[target.name] = target.value;
        fields['studentname'] = fields['name']+' '+fields['family'];
        this.setState({fields});
    }

    handleSubmit3(event){
        event.preventDefault();

        this.handleValidation3((valid)=>{
            if (valid){
                this.handleRequest3();
            } else {
                const {errors} = this.state;
            }
        });

    }
    handleValidation3(callback){
        let { fields } = this.state;
        let errors = this.state.errors;
        let formIsValid = true;

        if (fields.name === ""){
            formIsValid = false;
            errors['name'] = 'لطفا نام هنرجو را وارد کنید!';
        }else {
            errors['name'] = null;
        }

        if (fields.family===""){
            formIsValid = false;
            errors['family'] = 'لطفا نام خانوادگی هنرجو را وارد کنید!';
        }else {
            errors['family'] = null;
        }
        if (fields.studentphone === ""){
            formIsValid = false;
            errors['studentphone'] = 'لطفا شماره تلفن هنرجو را وارد کنید!';
        }else {
            errors['studentphone'] = null;
        }

        if (!fields.studentphone.startsWith('09')){
            formIsValid = false;
            errors['studentphone'] = 'لطفا شماره تلفن را با فرمت 09xxxxxxxxx وارد کنید!';
        }else if (fields.studentphone.startsWith('09')){
            errors['studentphone'] = null;
        }
        this.setState({errors}, ()=>{
            return callback(formIsValid);
        });
    }
    handleRequest3(){
        const {name,family,studentname, studentphone} = this.state.fields;
        sessionStorage.setItem("studentname",studentname);
        sessionStorage.setItem("studentphone",studentphone);
        this.setState({
            dialog:
                <Dialog aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        open={this.state.open}
                        className="text-right"
                        onClose={() => this.handleClose()}>
                    <DialogContent>
                        <DialogContentText className="text-center" id="alert-dialog-description">
                            <div id="loading" className="d-flex mt-3 justify-content-center animate__animated animate__zoomIn">
                                <h4>درحال بارگذاری ...</h4>
                                <CircularProgress className="mr-3" color="secondary"/>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

        });

        let data = new FormData();
        data.append('name', name);
        data.append('family', family);
        data.append('phone', studentphone);
        axios.post(Data.mainserver+'Register.php',data)
            .then(response2=>{
                console.log("request",response2.data);

                this.handleClose();
                try {
                    let res2 = JSON.parse(JSON.stringify(response2.data));

                    if (res2.hasOwnProperty("token")){
                        this.handleReg();
                    }
                    
                }catch (e){
                    console.log(e);
                
                }
                if (response2.data === "duplicate_phone"){
                    this.handleReg();
                }
            }).catch(error => {
                console.log(error);
            });

    }

    handleReg(){
        this.setState({
            dialog:
                <Dialog aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        open={this.state.open}
                        className="text-right"
                        onClose={() => this.handleClose()} >
                    <DialogContent>
                        <DialogContentText className="text-center" id="alert-dialog-description">
                            <div id="loading" className="d-flex mt-3 justify-content-center animate__animated animate__zoomIn">
                                <h4>درحال بارگذاری ...</h4>
                                <CircularProgress className="mr-3" color="secondary"/>
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    
                </Dialog>

        });

        const {classinfo} = this.state;
        let token = localStorage.getItem('token');
        let data2 = new FormData();
        data2.append('token', token);
        data2.append('id', classinfo['id']);
        axios.post(Data.mainserver+`getClass3.php`,data2)
        .then(response => {
            console.log("reg",response.data);

            if (response.data.hasOwnProperty('data')) {

                    const {data} = response.data;
                    $('#masters').removeClass('novisible');

                    let token = AES128.encrypt(AES128.keyy,AES128.ivv,data[0]['id']);

                    var qp = new URLSearchParams(window.location.search);
                    qp.set("token",token);

                    window.location.href = '/pay?'+qp.toString();

            }
                if (response.data.hasOwnProperty('no_item')){
                    $('#no_item').removeClass('novisible');
                }
                $('#select_instrument').removeClass('novisible');
                $('#loading').addClass('novisible');


            })
            .catch(error => {
                console.log(error);
            });
    }

    componentDidMount(){
        // let studentname = sessionStorage.getItem('studentname');
        // let studentphone = sessionStorage.getItem('studentphone');

        // this.setState({
        //     studentname:studentname,
        //     studentphone:studentphone
        // });
    }
    handleReq(data){
        sessionStorage.setItem("studentname",data['studentname']);
        sessionStorage.setItem("studentphone",data['studentphone']);

        let fields = {
            name:data['name'],
            family:data['family'],
            studentname:data['studentname'],
            studentphone:data['studentphone'],

        };
                this.setState({
                    fields:fields,
                    openReg:true,
                    classinfo: data
                });
    }

    handleClose() {
        this.setState({
            dialog:<div/>
        })
    };

    handleCloseReg(e) {
        e.preventDefault();

        this.setState({
            openReg:false
        })
    };

    render() {
        const {data,noinfo} = this.props;
        const {errors,time,dialog} = this.state;
        const {name,family,studentname, studentphone} = this.state.fields;

        return (
            <div className="container text-center">

<Dialog aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                open={this.state.openReg}
                                className="text-right"
                                onClose={this.handleCloseReg.bind(this)} >
                                    <DialogTitle>اطلاعات هنرجو</DialogTitle>
                            <DialogContent>
                                    <div id="loading" className="d-flex justify-content-center">
                                    <form onSubmit={this.handleSubmit3.bind(this)} className="login-form mx-auto">
                    <div className="form-group text-right">
                        <label>نام</label>
                        <input
                            type="text"
                            className={["form-control", errors['name'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="name"
                            value={name}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا نام هنرجو وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['name'] ? 'block':'none'}}>{errors['name']}</span>
                    </div>
                    <div className="form-group text-right">
                    <label>نام خانوادگی</label>
                        <input
                            type="text"
                            className={["form-control", errors['family'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="family"
                            value={family}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا نام خانوادگی هنرجو وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['family'] ? 'block':'none'}}>{errors['family']}</span>
                    </div>
                    <div className="form-group text-right">
                    <label>شماره تلفن</label>
                        <input
                            type="text"
                            className={["form-control", errors['studentphone'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="studentphone"
                            value={studentphone}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا شماره تلفن هنرجو وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['studentphone'] ? 'block':'none'}}>{errors['studentphone']}</span>
                    </div>
                    
                    <div className="form-group text-center">
                        <button type="submit" className="btn btn-success btn-block">ثبت نام</button>
                    </div>
                    <div className="form-group text-center">
                        <button onClick={this.handleCloseReg.bind(this)} className="btn btn-danger btn-block">لغو</button>
                    </div>


                </form>
                                    </div>
                            </DialogContent>
                        
                        </Dialog>
        
                <div className="section-title">
                    <h3>{"لیست کلاس ها"}</h3>
                </div>

                {dialog}

                <ul className=" nav nav-pills nav-fill flex-sm-row">
                    {data.map((d,i) =>
                        <li key={i} className="nav-item">
                            <a className={i===0?"flex-sm-fill nav-link active":"flex-sm-fill nav-link"} data-toggle="tab" href={"#day"+i}>{d['dayname']+ " ها"}</a>
                        </li>

                    )}
                </ul>

                <div className="tab-content text-center p-3">

                    {data.map((d,i) =>
                        <div key={i} className={i===0?"tab-pane fade show active":"tab-pane fade"} id={"day"+i}>
                            <div className="row">
                                {data[i]['masters'].map((dd,index) =>
                                    <div className="col-12 col-md-12 col-lg-6" key={index}>
                                        <div className="card box-shadow mt-4 ">

                                            <div className="card-body">
                                                <strong className="h5 p-1">{"کلاس "+dd['instrumentname']} <img height="38px" width="38px" src={Data.server+"icons/"+dd['instrumentpic']} alt={"آموزش "+dd['instrumentname']+" - کلاس"+dd['instrumentname']}/></strong>
                                                <img className="circle-icon" height="128" width="128"
                                                     src={dd['masterpic']===''?Data.server+"icons/user.png":Data.server + "images/" + dd['masterpic']} alt={"استاد "+dd['mastername']}/>
                                                <h6 className="mt-2">{"استاد "+dd['mastername']}</h6>
                                                {noinfo==="yes"?<div />:<a target="_blank" href={dd['masteruserid']!==null?Data.mainserver+"/masters/"+dd['masteruserid']:Data.mainserver+"/masters/"+dd['masterid']}>مشاهده مشخصات</a>}
                                            

                                            </div>
                                            <div className="card-footer text-center d-flex flex-column justify-content-center align-items-center">
                                                {dd['infos'].map((d,i) => <div onClick={() => this.handleReq(d)} className={d['reserved']==="yes"?"btn btn-secondary text-center mt-3 w-100":d['reserve']==="no"?"btn btn-success text-center mt-3 w-100":"btn btn-danger text-center mt-3 w-100"} key={i}>
                                                    <h4 className="text-white">{d['time']}</h4>
                                                    <h6 className="text-white">{d['studentname'] !== null?d['studentname']:""}</h6>
                                                    <h6 className="text-white">{d['studentname'] !== null && d['studentname']!==""?d['reserve_time']:""}</h6>
                                                </div>)}
                                            </div>
                                        </div>

                                    </div>
                                )}

                            </div>
                        </div>
                    )}
                </div>

            </div>
        );
    }
}


export default Classes;
